import { ErrorBoundary, ErrorBoundaryProps } from '@ets/design-system';
import { useIntl } from 'react-intl';

type IntlErrorBoundaryProps = {
  disabled?: boolean;
  collapsed?: boolean;
} & ErrorBoundaryProps;

const IntlErrorBoundary = ({
  disabled,
  collapsed,
  children,
  label,
  tooltipSide,
  ...fallbackProps
}: IntlErrorBoundaryProps) => {
  const intl = useIntl();

  if (disabled || import.meta.env.MODE === 'test') {
    return <>{children}</>;
  }
  return (
    <ErrorBoundary
      {...fallbackProps}
      tooltipContent={
        collapsed
          ? (label ?? intl.formatMessage({ id: 'COULD_NOT_RETRIEVE_INFORMATION' }))
          : undefined
      }
      tooltipSide={collapsed ? tooltipSide : undefined}
      label={
        collapsed
          ? undefined
          : (label ?? intl.formatMessage({ id: 'COULD_NOT_RETRIEVE_INFORMATION' }))
      }
    >
      {children}
    </ErrorBoundary>
  );
};

export default IntlErrorBoundary;
